import { Table } from "@zendeskgarden/react-tables";
import * as Css from "./styles"
import { Props } from "./bulkResultTableType";
import IconBack from '@zendeskgarden/svg-icons/src/16/face-sad-stroke.svg?react';

const translateErrorMessage = (message: string): string => {
    if (!message) return message;
    
    const translations: Record<string, string> = {
        "is already being used by another user": "já está sendo usado por outro usuário",
        "Email:": "E-mail:",
        "is invalid": "é inválido",
        "is required": "é obrigatório",
        "cannot be blank": "não pode estar vazio",
        "has already been taken": "já foi utilizado",
        "must be": "deve ser",
        "is not valid": "não é válido",
    };
    
    let translated = message;
    for (const [english, portuguese] of Object.entries(translations)) {
        translated = translated.replace(new RegExp(english, 'gi'), portuguese);
    }
    
    return translated;
};

export default function BulkResultsTable({ results, type }: Props) {
    const flatResults: any[] = [];

    for (const jobResult of results) {
        if (jobResult.results && Array.isArray(jobResult.results)) {
            for (const ticketResult of jobResult.results) {
                flatResults.push({
                    ...ticketResult,
                    job_status: jobResult.status,
                    job_success: jobResult.success,
                    isUserCreated: ticketResult.status === "Created",
                    job_url: jobResult.url
                });
            }
        } else {
            flatResults.push({
                id: null,
                job_status: jobResult.status,
                job_success: jobResult.success,
                error: jobResult.error,
                job_url: jobResult.url
            });
        }
    }
    
    const hasCriticalError = flatResults.length === 0;

    const errorCount = flatResults.filter(r => {
        const success = type === "user" ? r?.isUserCreated : r?.id && r?.job_success;
        return !success;
    }).length;

    const errorList = flatResults
        .filter(r => {
            const success = type === "user" ? r?.isUserCreated : r?.id && r?.job_success;
            return !success;
        })
        .map((r, i) => {
            let errorMessage = "";
            if (type === "user") {
                errorMessage = r?.details || r?.error || "Erro desconhecido";
            } else if (type === "organization") {
                errorMessage = r?.errors || "Erro desconhecido";
            } else {
                errorMessage = r?.details || r?.error || r?.message || "Erro desconhecido";
            }

            const identifier = type === "user" ? (r?.name || r?.email || `#${i}`) :
                type === "organization" ? (r?.name || `#${i}`) :
                    `#${r?.id || i}`;

            return {
                identifier,
                message: translateErrorMessage(errorMessage)
            };
        });

    const hasErrors = errorCount > 0;

    return (
        <Css.StyledContainer>
            {
                hasCriticalError ? (
                    <Css.ErrorState>
                        <h3>Erro na criação <IconBack /></h3>
                        <p>
                            Ocorreu um problema ao processar os dados.
                            <br />
                            Por favor, atualize a página e tente novamente.
                        </p>
                    </Css.ErrorState>
                ) : (
                    <>
                        {hasErrors && (
                            <Css.ErrorSummary>
                                <Css.ErrorSummaryHeader>
                                    <h3>Erros encontrados </h3>
                                    <span>
                                        <strong>{errorCount}</strong> {errorCount === 1 ? "erro encontrado" : "erros encontrados"}
                                    </span>
                                </Css.ErrorSummaryHeader>
                                <Css.ErrorList>
                                    {errorList.slice(0, 10).map((err, i) => (
                                        <Css.ErrorItem key={i}>
                                            <Css.ErrorItemLabel>
                                                <strong>{err.identifier}</strong>
                                            </Css.ErrorItemLabel>
                                            <Css.ErrorItemMessage>{err.message}</Css.ErrorItemMessage>
                                        </Css.ErrorItem>
                                    ))}
                                    {errorList.length > 10 && (
                                        <Css.ErrorItem>
                                            <Css.ErrorItemMessage style={{ fontStyle: 'italic', color: '#666' }}>
                                                ...e mais {errorList.length - 10} erros. Veja todos na tabela abaixo.
                                            </Css.ErrorItemMessage>
                                        </Css.ErrorItem>
                                    )}
                                </Css.ErrorList>
                            </Css.ErrorSummary>
                        )}

                        <Table style={{ minWidth: 600 }}>
                            <Table.Head>
                                <Table.HeaderRow>
                                    <Table.HeaderCell>Status</Table.HeaderCell>
                                    <Table.HeaderCell>
                                        {type === "user"
                                            ? "Usuário"
                                            : type === "organization"
                                                ? "Organização"
                                                : "Ticket"}
                                    </Table.HeaderCell>

                                    <Table.HeaderCell>ID Criado</Table.HeaderCell>
                                    <Table.HeaderCell>Mensagem de Erro</Table.HeaderCell>
                                </Table.HeaderRow>
                            </Table.Head>

                            <Table.Body>
                                {flatResults.map((r, i) => {
                                    const success =
                                        type === "user"
                                            ? r?.isUserCreated
                                            : r?.id && r?.job_success;


                                    return (
                                        <Table.Row key={i}>
                                            <Table.Cell>
                                                <Css.StatusPill $success={success}>
                                                    {success ? "Sucesso" : "Erro"}
                                                </Css.StatusPill>
                                            </Table.Cell>

                                            <Table.Cell>
                                                {type === "user" && (r?.name || r?.email || "-")}
                                                {type === "organization" && (r?.name || "-")}
                                                {type === "ticket" && (
                                                    r?.id
                                                        ? `Ticket #${r.id}`
                                                        : "-"
                                                )}
                                            </Table.Cell>

                                            <Table.Cell>{success ? r?.id || "-" : "-"}</Table.Cell>

                                            <Table.Cell>
                                                {type === "user"
                                                    ? translateErrorMessage(r?.details || r?.error || "Nenhum erro")
                                                    :
                                                    type === "organization"
                                                        ?
                                                        translateErrorMessage(r?.errors || "Nenhum erro")
                                                        :
                                                        (r?.details || r?.error || r?.message || "Nenhum erro") && (
                                                            <div>
                                                                {translateErrorMessage(r?.details || r?.error || r?.message || "Nenhum erro")}
                                                            </div>
                                                        )}

                                            </Table.Cell>
                                        </Table.Row>
                                    );
                                })}

                            </Table.Body>
                        </Table>
                    </>
                )
            }

        </Css.StyledContainer>
    );
}
